module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/earrings/couture-423d01afc5bdc72a9364ddfc5d8f4142.webp";